var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSendFilled = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.46857 8.38038L7.46527 8.40019C7.55767 8.40019 7.60388 8.43981 7.60388 8.53887L7.61708 13.5248C7.61708 14.1522 7.89431 14.6673 8.41576 14.6673C8.91741 14.6673 9.18804 14.1984 9.42566 13.6767L14.4818 2.78024C14.6072 2.52269 14.6666 2.29155 14.6666 2.10004C14.6666 1.66418 14.3432 1.33398 13.9009 1.33398C13.7029 1.33398 13.4719 1.38682 13.2144 1.51229L2.32335 6.5643C1.8217 6.79543 1.33325 7.0728 1.33325 7.5813C1.33325 8.0898 1.8217 8.38038 2.46857 8.38038Z",
    fill: "#908CA0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSendFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/send-filled.307e70593ce84cf3c0c97bc4327b707b.svg";